import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConvertCoordinatesComponent } from './convert-coordinates.component';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { IconicModule } from '../../../iconic/iconic.module';
import { ButtonModule } from '../../../button/button.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { TextAreaModule } from '../../../text-area/text-area.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';

@NgModule({
  imports: [
    CommonModule,
    ScrollViewModule,
    ButtonModule,
    TextAreaModule,
    IconicModule,
    SelectBoxModule,
    TooltipModule,
    BlockModalDragModule,
  ],
  declarations: [ConvertCoordinatesComponent],
  exports: [ConvertCoordinatesComponent],
})
export class ConvertCoordinatesModule {}
